import { render, staticRenderFns } from "./ExtraServiceHistory.vue?vue&type=template&id=5418963a&"
import script from "@/scripts/extraService/extraServiceHistory.js?vue&type=script&lang=js&"
export * from "@/scripts/extraService/extraServiceHistory.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports